import { render, staticRenderFns } from "./GradeItem.vue?vue&type=template&id=929bdbda&scoped=true&"
import script from "./GradeItem.vue?vue&type=script&lang=js&"
export * from "./GradeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929bdbda",
  null
  
)

export default component.exports